import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './component/MainLayout';
import Event from './component/Event';
import TopBar from './component/TopBar';
import './styles/sass/style.scss';
import Video from './component/Video';
import Community from './component/Community';
import ContactUs from './component/ContactUs';
import EventShow from './component/EventShow';
import News from './component/News';
import GalleryView from './component/mainLayout/GalleryView';
import Footer from './component/mainLayout/Footer';
import APIData from './component/mainLayout/APIData';
import Section1View from './component/Section1View';
import Artical from './component/mainLayout/Artical';


const App = () => {
  
  return (
    <Router>
      <TopBar /> 
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/event" element={<Event />} />
        <Route path="/event/details" element={<EventShow />} />
        <Route path="/artical/details" element={<Artical />} />
        <Route path="/video" element={<Video />} />
        <Route path="/news" element={<News/>} />
        <Route path="/community" element={<Community />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/galleryView" element={<GalleryView />} />
      </Routes>
      <Footer/>
      <APIData/>

    </Router>
  );
};

export default App;
